// extracted by mini-css-extract-plugin
export default {"navbox":"CustomNavbar_navbox__abSt7","mail":"CustomNavbar_mail__apjJE","search":"CustomNavbar_search__5Z2Xf","icon":"CustomNavbar_icon__XFq4R"};